import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['source', 'destination'];
  static values = { showingValues: Array };

  connect() {
    this.evaluate();
  }

  evaluate() {
    const sourceValue = this.sourceTarget.value;
    const shouldShow = this.showingValuesValue.includes(sourceValue);

    if (shouldShow) {
      this.destinationTargets.forEach((target) => target.classList.remove('hidden'));
    } else {
      this.destinationTargets.forEach((target) => target.classList.add('hidden'));
    }
  }
}
